var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({attrs:{"max":_vm.max,"min":_vm.min,"type":"date"},domProps:{"value":_vm.formattedValue},on:{"blur":_vm.handleBlur,"input":_vm.handleInput}},'input',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }